import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

function useFilterParams(defaultInit) {
  const [searchParams, setSearchParams] = useSearchParams();

  const setParam = (label, value) => {
    setSearchParams(cur => {
      if (!value) {
        delete cur.delete(label);
      } else {
        cur.set(label, value);
      }
      return cur;
    });
  };

  const getParam = label => {
    const value = searchParams.get(label);
    if (!value) return undefined;

    if (!isNaN(value)) {
      if (value < 6465432135435436) return parseInt(value);
    }

    return value;
  };

  const getAllParams = () => Object.fromEntries([...searchParams]);

  useEffect(() => {
    if (!defaultInit) return;

    Object.keys(defaultInit).forEach(item => {
      if (!getParam(item)) {
        setParam(item, defaultInit[item]);
      }
    });
  }, []);

  return { getParam, setParam, getAllParams };
}

export default useFilterParams;
